<template>
  <CoreBottomSheet
    v-model="isOpened"
    data-qa="capture_type_list"
  >
    <template #default="{ xSpaceClass, counterXSpaceClass }">
      <v-list :class="counterXSpaceClass">
        <v-list-item
          class="py-1"
          data-qa="capture_type_list_item_photo_environment"
          :class="xSpaceClass"
          @click="emit('choice-capture', 'environment')"
        >
          {{ t('Сделать фото', options) }}
        </v-list-item>
        <v-list-item
          class="py-1"
          data-qa="capture_type_list_item_gallery"
          :class="xSpaceClass"
          @click="emit('choice-capture', false)"
        >
          {{ t('Загрузить из галереи', options) }}
        </v-list-item>
      </v-list>
    </template>
  </CoreBottomSheet>
</template>

<script lang="ts" setup>
import I18NextVue from 'i18next'
import { computed } from 'vue'
import CoreBottomSheet from 'src/core/CoreBottomSheet/CoreBottomSheet.vue'
import type { CaptureType } from 'src/core/CoreFilePicker/types'

const { t, language } = I18NextVue
const options = { ns: language }

const props = defineProps<{
  value: boolean
}>()

type Emits = {
  (_event: 'input', _value: boolean): void
  (_event: 'choice-capture', _value: CaptureType): void
}

const emit = defineEmits<Emits>()

const isOpened = computed({
  get() {
    return props.value
  },
  set(value: boolean) {
    emit('input', value)
  },
})
</script>
